/**
 * Application-level Vital export targets. This is deliberately separate from
 * the `synth_version` field embedded in a .vital payload: that field controls
 * Vital's internal preset migrations, not the installed product version.
 */
export const VITAL_TARGET_VERSIONS = ["1.0.7", "1.6.4"];
export const DEFAULT_VITAL_TARGET_VERSION = "1.0.7";
/**
 * 1.6.4 preserves the current adapter payload byte-for-byte. 1.0.7 uses the
 * same conservative migration marker until native fixture probing identifies
 * a field that needs a legacy mapping.
 */
export const VITAL_EXPORT_PROFILES = {
    "1.6.4": {
        targetVersion: "1.6.4",
        label: "Vital 1.6.4",
        stability: "early_access",
        synthVersion: "1.0.0",
        compatibility: "provisional",
    },
    "1.0.7": {
        targetVersion: "1.0.7",
        label: "Vital 1.0.7",
        stability: "stable",
        synthVersion: "1.0.0",
        compatibility: "provisional",
    },
};
const TARGET_VERSION_SET = new Set(VITAL_TARGET_VERSIONS);
export function isVitalTargetVersion(value) {
    return typeof value === "string" && TARGET_VERSION_SET.has(value);
}
export function resolveVitalExportProfile(targetVersion = DEFAULT_VITAL_TARGET_VERSION) {
    return VITAL_EXPORT_PROFILES[targetVersion];
}
//# sourceMappingURL=target-version.js.map